import actions from './actions';

const initialState = {
    vales:       [],
    currentVale: null,
    loading:     false,
};

export default function ValesConsumoReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_LOADING:
            return { ...state, loading: action.value };
        case actions.GET_VALES_SUCCESS:
            return { ...state, vales: action.payload, loading: false };
        case actions.GET_VALE_SUCCESS:
            return { ...state, currentVale: action.payload, loading: false };
        case actions.UPDATE_ESTADO_VALE_SUCCESS:
            return {
                ...state,
                vales: state.vales.map(v => v._id === action.id ? { ...v, estado: action.estado } : v),
                currentVale: state.currentVale?._id === action.id
                    ? { ...state.currentVale, estado: action.estado }
                    : state.currentVale,
                loading: false,
            };
        default:
            return state;
    }
}
